import { Box, Icon, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

interface InnerNotificationProps {
  message?: string
  icon?: ReactElement
  textColor?: string
  bgColor?: string
  paragraphSize?: number
}

export const InnerNotification: React.FC<InnerNotificationProps> = ({
  message,
  icon,
  textColor,
  bgColor,
  paragraphSize
}) => {
  return (
    <Box
      color={textColor}
      bgcolor={bgColor}
      p={paragraphSize}
      width={'90%'}
      textAlign='center'
      margin={'10% 0'}
    >
      <Icon>{icon}</Icon>
      <Typography style={{ paddingLeft: '10px' }}>{message}</Typography>
    </Box>
  )
}
